// extracted by mini-css-extract-plugin
export var alignCenter = "_89-d";
export var bannerShown = "_89-6";
export var buttonContent = "_89-0";
export var cardList = "_89-1";
export var centerContent = "_89-2";
export var chevron = "_89-3";
export var closePanelButton = "_89-k";
export var conversationContextContainer = "_89-l";
export var conversationDetailContainer = "_89-4";
export var detailWrapper = "_89-7";
export var dropdownButton = "_89-e";
export var dropdownTitle = "_89-9";
export var fullHeight = "_89-5";
export var hidden = "_89-a";
export var icon = "_89-b";
export var mergeSuggestionWrapper = "_89-m";
export var panel = "_89-i";
export var portalButtonsWrapper = "_89-c";
export var right = "_89-j";
export var tableSummaryContainer = "_89-8";
export var tableSummaryHeader = "_89-g";
export var threeDotsButton = "_89-f";
export var wide = "_89-h";